import { gql } from "@outschool/ui-apollo";

export const createAiGuideSupportIssueMutation = gql`
  mutation CreateAiGuideSupportIssue($userMessage: String!) {
    createAiGuideSupportIssue(userMessage: $userMessage)
  }
`;
